import React, {createContext, useState} from 'react';
import {ACCESS_TOKEN} from '../helpers/APIURL';
import AuthService from "../services/AuthService";
import {Toast} from "../components/common/Toast";
import UserService from "../services/UserService";
import {getErrorMessage} from "../helpers/Utils";

export const AuthContext = createContext("AuthContext");

const auth = localStorage.getItem(ACCESS_TOKEN);

const AuthContextProvider = ({children}) => {

    const [isLogin, setIsLogin] = useState(!!auth);
    const [profile, setProfile] = useState(null);
    const [selectedRestaurant, setSelectedRestaurant] = useState(null);
    const [loading, setLoading] = useState(false);
    const [profileLoading, setProfileLoading] = useState(false);
    const [roles, setRoles] = useState([]);

    const login = async (credential) => {

        try {
            setLoading(true);
            const response = await AuthService.login(credential);
            localStorage.setItem(ACCESS_TOKEN, response.data.token.access);
            setRoles(response.data.user.roles);
            setIsLogin(true);
            setLoading(false);
        } catch (error) {
            const message = getErrorMessage(error);
            Toast("error", "Error", message);
            setLoading(false);
            setIsLogin(false);
        }

    }

    const getUserProfile = async () => {

        try {
            setProfileLoading(true);
            const response = await UserService.getUserProfile();

            const _data = response.data;
            _data.fullName = _data.info.fullName;

            setProfile(_data);
            if (_data.restaurants) {
                setSelectedRestaurant(_data.restaurants[0]);
            }
            setProfileLoading(false);
        } catch (error) {
            const message = getErrorMessage(error);
            Toast("error", "Error", message);
            setProfileLoading(false);
        }

    }

    const updateProfilePicture = data => {
        setProfile({...profile, info: data})
    }

    const logout = () => {
        setIsLogin(false);
        setSelectedRestaurant(null);
        localStorage.clear();
    }

    return (
        <AuthContext.Provider
            value={{
                isLogin,
                profile,
                loading,
                profileLoading,
                permissions: profile ? profile.permissions : [],
                restaurants: profile?.restaurants,
                roles,
                selectedRestaurant,
                updateProfilePicture,
                login,
                logout,
                getUserProfile
            }}
        >
            {children}
        </AuthContext.Provider>
    );
}

export default AuthContextProvider;
